import { makeStyles } from 'tss-react/mui';

interface Props {
  aspectRatio: string | null;
}

const useStyles = makeStyles<Props>({
  name: 'VimeoVideo',
})(({ typography, aspectRatio }, props) => ({
  container: {
    position: 'relative',
    aspectRatio: props.aspectRatio || aspectRatio['16/9'],
    /* Required because of existing bug with react player library
     * https://github.com/CookPete/react-player/issues/810
     */
    '& iframe': {
      width: '100%',
      height: '100%',
    },
  },
  absoluteFill: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
  },
  thumbnail: {
    zIndex: 1,
    objectFit: 'cover',
  },
  hidden: {
    visibility: 'hidden',
  },
  rounded: {
    '& > div': {
      borderRadius: typography.pxToRem(16),
    },
    // Ensure the iframe wrapper div inside respects border-radius
    '& > div > div': {
      borderRadius: typography.pxToRem(16),
      overflow: 'hidden',
    },
  },
}));

export default useStyles;
